import { ConfigProvider, Pagination } from "antd";
import React, { useMemo, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { clStatusOptions, stStatusOptions } from "../../../static/dropdown";
import { fetchDataByQuery } from "../../../service/dataExport";
import { allCvReport } from "../../../static/reportQuery";

const ClTables = ({
  allClReports,
  allClLoading,
  clUniReport,
  clUniLoading,
  allUserClLoading,
  allUserClReports,
  allClKpiReports,
  allClKpiLoading,
  studentReport,
  studentReportLoading,
}) => {
  const rowsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesLimit, setEntriesLimit] = useState(rowsPerPage);
  const [universitySearch, setUniversitySearch] = useState("");
  const [courseSearch, setCourseSearch] = useState("");
  const hasClKpiData =
    allClKpiReports &&
    typeof allClKpiReports === "object" &&
    Object.keys(allClKpiReports).length > 0;

  const hasClData =
    allClReports &&
    typeof allClReports === "object" &&
    Object.keys(allClReports).length > 0;

  const hasClUniReport = Array.isArray(clUniReport) && clUniReport.length > 0;
  const hasStudentReport = studentReport && studentReport.length > 0;
  const hasClUserUniReport =
    Array.isArray(allUserClReports) && allUserClReports.length > 0;
  
  const filteredData = useMemo(() => {
    if (!Array.isArray(clUniReport)) return [];

    return clUniReport.filter((item) => {
      const uni = item.UNIVERSITYNAME?.toLowerCase() || "";
      const course = item.COURSENAME?.toLowerCase() || "";
      const uniMatch = uni.includes(universitySearch.toLowerCase());
      const courseMatch = course.includes(courseSearch.toLowerCase());
      return uniMatch && courseMatch;
    });
  }, [clUniReport, universitySearch, courseSearch]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * entriesLimit;
    const endIndex = startIndex + entriesLimit;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, currentPage, entriesLimit]);

  const getClStatusName = (code) => {
    if (!code && code !== 0) return "Unknown"; // handles null, undefined, empty string

    const res = clStatusOptions?.find((item) => item.value === parseInt(code));

    return res?.label || "Unknown";
  };
  const getStudentStatus = (code) => {
    const res = stStatusOptions?.find((item) => item.value === parseInt(code));
    return res?.label;
  };

  return (
    <div>
      {!studentReportLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="bg-white mb-2">
                <span className="fs-5 fw-bold">All CL Reports</span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1">
                {hasStudentReport ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr className="text-nowrap">
                        <th>Total Students</th>
                        {studentReport?.map((item, idx) => (
                          <th key={idx}>{getStudentStatus(item?.STSTATUS)}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center">
                        <td>{allClReports?.totalStudents?.count || 0}</td>
                        {studentReport?.map((item, idx) => (
                          <td key={idx}>{item?.Column1}</td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}
      {!allClKpiLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className=" bg-transparent">
                <span className="fs-5 fw-bold text-dark">
                  Course List App Status Reports
                </span>
              </div>
              <div className="py-3 overflow-auto" style={{ maxHeight: "60vh" }}>
                {hasClKpiData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr className="text-center">
                        <th>Approved</th>
                        <th>Not Approved</th>
                        <th>Under Evaluation</th>
                        <th>Not Updated</th>
                      </tr>
                    </thead>
                    <tbody className="text-center cursor-pointer">
                      <th
                        onClick={() =>
                          fetchDataByQuery(
                            allClKpiReports?.totalApprClStudents?.query,
                            allCvReport.total_cl_students,
                            "Confirm to download .csv"
                          )
                        }
                      >
                        {allClKpiReports?.totalApprClStudents?.count}
                      </th>
                      <th
                        onClick={() =>
                          fetchDataByQuery(
                            allClKpiReports?.totalNotApprClStudents?.query,
                            allCvReport.total_cl_students,
                            "Confirm to download .csv"
                          )
                        }
                      >
                        {allClKpiReports?.totalNotApprClStudents?.count}
                      </th>
                      <th
                        onClick={() =>
                          fetchDataByQuery(
                            allClKpiReports?.underEval?.query,
                            allCvReport.total_cl_students,
                            "Confirm to download .csv"
                          )
                        }
                      >
                        {allClKpiReports?.underEval?.count}
                      </th>
                      <th
                        onClick={() =>
                          fetchDataByQuery(
                            allClKpiReports?.notUpdated?.query,
                            allCvReport.total_cl_students,
                            "Confirm to download .csv"
                          )
                        }
                      >
                        {allClKpiReports?.notUpdated?.count}
                      </th>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!allClLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className=" bg-transparent">
                <span className="fs-5 fw-bold text-dark">
                  Course List Reports
                </span>
              </div>
              <div className="py-3 overflow-auto">
                {hasClData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr className="text-nowrap">
                        <th>Total Students</th>
                        <th>Not Updated</th>
                        <th>In Process</th>
                        <th>Need To Discuss</th>
                        <th>CL Created</th>
                        <th>Discussed Not Shared</th>
                        <th>Discussed But Can't Share</th>
                        <th>Need to Share</th>
                        <th>Shared</th>
                        <th>Partial Final</th>
                        <th>Exceptionally Final</th>
                        <th>Final and Reopen</th>
                        <th>Final</th>
                        {/* <th>Total Approved Application</th>
                        <th>Approved Public Application</th>
                        <th>Approved Private Application</th>
                        <th>Application Type Not Updated</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center cursor-pointer">
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.totalStudents?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.totalStudents?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.notUpdated?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.notUpdated?.count || 0}
                        </td>

                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.inProcess?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.inProcess?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.needToDiscuss?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.needToDiscuss?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.clCreated?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.clCreated?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.discussNotShared?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.discussNotShared?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.discussCantShared?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.discussCantShared?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.needToShared?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.needToShared?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.shared?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.shared?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.partiaFinal?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.partiaFinal?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.expFinal?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.expFinal?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.finalReopen?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.finalReopen?.count || 0}
                        </td>
                        <td
                          onClick={() =>
                            fetchDataByQuery(
                              allClReports?.final?.query,
                              allCvReport.total_students,
                              "Confirm to download .csv"
                            )
                          }
                        >
                          {allClReports?.final?.count || 0}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!allUserClLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="mb-3">
                <span className="fs-5 fw-bold text-dark">
                  Course List Reports (Team Wise)
                </span>
              </div>
              <div className="overflow-auto" style={{ maxHeight: "60vh" }}>
                {hasClUserUniReport ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead
                      className="sticky-top"
                      style={{ zIndex: 10, background: "yellow" }}
                    >
                      <tr className="text-nowrap">
                        <th>#</th>
                        <th>Assigned User</th>
                        <th>Total Students</th>
                        <th>Not Updated</th>
                        <th>In Process</th>
                        <th>Need To Discuss</th>
                        <th>CL Created</th>
                        <th>Discussed Not Shared</th>
                        <th>Discussed But Can't Share</th>
                        <th>Need to Share</th>
                        <th>Shared</th>
                        <th>Partial Final</th>
                        <th>Exceptionally Final</th>
                        <th>Final and Reopen</th>
                        <th>Final</th>
                        {/* <th>Total Approved Application</th>
                        <th>Approved Public Application</th>
                        <th>Approved Private Application</th>
                        <th>Application Type Not Updated</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {allUserClReports?.map(({ name, details }, idx) => (
                        <tr key={idx} className="text-center cursor-pointer">
                          <td>{idx + 1}</td>
                          <td className="text-start">{name}</td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.totalStudents?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.totalStudents?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.notUpdated?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.notUpdated?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.inProcess?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.inProcess?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.needToDiscuss?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.needToDiscuss?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.clCreated?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.clCreated?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.discussNotShared?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.discussNotShared?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.discussCantShared?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.discussCantShared?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.needToShared?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.needToShared?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.shared?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.shared?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.partiaFinal?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.partiaFinal?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.expFinal?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.expFinal?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.finalReopen?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.finalReopen?.count || 0}
                          </td>
                          <td
                            onClick={() =>
                              fetchDataByQuery(
                                details?.final?.query,
                                allCvReport.total_cl_userWise,
                                "Confirm to download .csv"
                              )
                            }
                          >
                            {details?.final?.count || 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="sticky-bottom">
                      <tr>
                        <th></th>
                        <th className="text-start">Total</th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.totalStudents?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.notUpdated?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.inProcess?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.needToDiscuss?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.clCreated?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.discussNotShared?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc +
                              (cur.details?.discussCantShared?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.needToShared?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.shared?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.partiaFinal?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.expFinal?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.finalReopen?.count || 0),
                            0
                          )}
                        </th>
                        <th className="text-center">
                          {allUserClReports.reduce(
                            (acc, cur) =>
                              acc + (cur.details?.final?.count || 0),
                            0
                          )}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!clUniLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="mb-3">
                <span className="fs-5 fw-bold text-dark">
                  University & Courses Reports
                </span>
                <div className="row bg-light">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search University"
                      value={universitySearch}
                      onChange={(e) => {
                        setUniversitySearch(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Course"
                      value={courseSearch}
                      onChange={(e) => {
                        setCourseSearch(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className=""
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasClUniReport ? (
                  <table className="table table-yesgermany table-hover table-bordered">
                    <thead
                      className="sticky-top"
                      style={{ zIndex: 10, background: "yellow" }}
                    >
                      <tr className="text-nowrap">
                        <th># {filteredData?.length}</th>
                        <th>University Name</th>
                        <th>Course Name</th>
                        <th>Total Approved Applications</th>
                        <th>Applied</th>
                        <th>Not Applied </th>
                        <th>Next First Step Deadline</th>
                        <th>Upcoming Deadline</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                          <td>{item.UNIVERSITYNAME}</td>
                          <td>{item.COURSENAME}</td>
                          <td className="text-center">
                            {item.APPROVED_APPLICATIONS}
                          </td>
                          <td className="text-center">
                            {item.APPLIED_APPLICATIONS}
                          </td>
                          <td className="text-center">
                            {item.NOT_APPLIED_APPLICATIONS}
                          </td>
                          <td className="text-center">
                            {item.FIRSTSTEPDEADLINEDATENEW}
                          </td>
                          <td className="text-nowrap">{item.DEADLINE}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {filteredData.length > entriesLimit && (
        <div className="d-flex justify-content-center mt-3 col-md-6 py-3">
          <ConfigProvider
            theme={{
              components: {
                Pagination: {
                  itemActiveBg: "#faf089",
                  itemActiveBgDisabled: "yellow",
                },
              },
              token: {
                colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                margin: 0,
              },
            }}
          >
            <Pagination
              current={currentPage}
              pageSize={entriesLimit}
              total={filteredData.length}
              showSizeChanger
              showQuickJumper
              onChange={(page) => setCurrentPage(page)}
              onShowSizeChange={(current, size) => {
                setEntriesLimit(size);
                setCurrentPage(1); // Reset to page 1 when page size changes
              }}
            />
          </ConfigProvider>
        </div>
      )}
    </div>
  );
};

export default ClTables;
